import { Button, Form, Modal, Switch } from "antd";
import { addSVG, deleteSVG, editSVG } from "../../assets/settings/SVGs";
import { useState } from "react";
import ModalAddFees from "../../components/settings/modal/ModalAddFees";
import { useIntl } from "react-intl";
type Props = {};

const ServicesFees = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [form] = Form.useForm();
  const data = [
    { name: "3", price: "200", cate: "كامل العملية" },
    { name: "3", price: "200", cate: "كامل العملية" },
    { name: "3", price: "200", cate: "كامل العملية" },
  ];
  const intl = useIntl();
  return (
    <>
      <Modal
        width={"50%"}
        open={isModalOpen}
        onCancel={handleCancel}
        className="max-md:!w-[95%] max-xl:!w-[75%]"
        footer={null}
      >
        <ModalAddFees close={handleCancel} />
      </Modal>
      <div className="text-color-primary text-2xl font-semibold leading-7 flex items-center gap-2 text-end">
        <span className="">
          {intl.formatMessage({ id: "serviceFeesSettings.title" })}
        </span>
      </div>
      <div className="my-4 text-color-gray text-base font-normal leading-7 ">
        {intl.formatMessage({ id: "serviceFeesSettings.description" })}
      </div>
      <Form form={form}>
        <div className="bg-[#EEF0FF] px-4 py-6 rounded-lg Taxes text-sm">
          <div className="bg-white p-4 rounded-lg w-full ">
            <div className="flex items-center justify-between">
              <span className="text-color-primary text-sm mb-auto">
                {intl.formatMessage({ id: "availableValues" })}
              </span>
              <Button
                type="primary"
                onClick={showModal}
                className="flex items-center justify-end gap-2 my-6"
              >
                {addSVG} {intl.formatMessage({ id: "addNew" })}
              </Button>
            </div>
            <div className="flex flex-col gap-4 items-center w-full pb-4">
              {data.map((e, index) => (
                <div
                  key={index}
                  className="flex text-sm max-md:text-xs items-center w-full justify-between gap-4 py-3 border-color-primary border-solid border-[1px] rounded-lg bg-[#FBFBFF] p-4"
                >
                  <div>
                    <span className="text-[#75757E]">
                      {intl.formatMessage({ id: "name" })}:
                    </span>
                    <span className="text-color-primary font-semibold">
                      #{e.name}
                    </span>
                  </div>
                  <div>
                    <span className="text-[#75757E]">
                      {intl.formatMessage({ id: "price" })}:
                    </span>
                    <span className="text-color-primary font-semibold">
                      {e.price} ر.س
                    </span>
                  </div>
                  <div>
                    <span className="text-[#75757E]">
                      {intl.formatMessage({ id: "category" })}:
                    </span>
                    <span className="text-color-primary font-semibold">
                      {e.cate}
                    </span>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="-mx-1 flex items-center">{editSVG}</span>
                    <span className="-mx-1 flex items-center">{deleteSVG}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};

export default ServicesFees;
